import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-262113de"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "graph" };
const _hoisted_2 = { key: 0 };
const _hoisted_3 = { class: "currency" };
const _hoisted_4 = { class: "title" };
const _hoisted_5 = { class: "total" };
const _hoisted_6 = { class: "material-symbols-outlined" };
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("canvas", { id: "allocation-chart" }, null, -1));
import { onMounted, watch } from 'vue';
import { useStore } from '@/store/store';
import { useBalancesGraph } from '@/logics/balances_graph';
import NoData from '@/materials/atoms/NoData.vue';
import MaterialIcon from '@/materials/atoms/MaterialIcon.vue';
import Loading from '@/materials/molecules/Loading.vue';
import { decimalize } from '@/logics/utils';
import { useMessage } from '@/const/messages';
import BalancesCheck from '@/components/organisms/main/trade/balances/BalancesCheck.vue';
export default /*#__PURE__*/ _defineComponent({
    setup(__props) {
        const store = useStore();
        const { format, BALANCES_TITLES } = useMessage();
        const { isLoading, total, baseCurrency, isShowAllData, changeShowAll, changeBase, refresh } = useBalancesGraph();
        onMounted(refresh);
        watch(() => [baseCurrency.value, store.state.userSettings.language, store.state.theme, isShowAllData.value], refresh);
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", null, [
                _createVNode(BalancesCheck, {
                    id: 2,
                    onChange: _unref(changeShowAll),
                    disabled: _unref(isLoading)
                }, null, 8, ["onChange", "disabled"]),
                _createElementVNode("div", _hoisted_1, [
                    _createVNode(NoData, {
                        "is-show": _unref(store).state.balances.length === 0
                    }, null, 8, ["is-show"]),
                    (_unref(store).state.balances.length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                            _createElementVNode("div", _hoisted_3, [
                                _createElementVNode("div", {
                                    class: _normalizeClass(["currency_p1", _unref(baseCurrency) === 'USD' || 'negative']),
                                    onClick: _cache[0] || (_cache[0] = ($event) => (_unref(changeBase)('USD')))
                                }, "USD", 2),
                                _createElementVNode("div", {
                                    class: _normalizeClass(["currency_p1", _unref(baseCurrency) === 'JPY' || 'negative']),
                                    onClick: _cache[1] || (_cache[1] = ($event) => (_unref(changeBase)('JPY')))
                                }, "JPY", 2),
                                _createElementVNode("div", {
                                    onClick: _cache[2] || (_cache[2] =
                                        //@ts-ignore
                                        (...args) => (_unref(refresh) && _unref(refresh)(...args))),
                                    class: "refresh"
                                }, [
                                    _createVNode(MaterialIcon, { name: "refresh" })
                                ])
                            ]),
                            _withDirectives(_createElementVNode("div", null, [
                                _createVNode(Loading, { mode: "sound" })
                            ], 512), [
                                [_vShow, _unref(isLoading)]
                            ]),
                            _withDirectives(_createElementVNode("div", null, [
                                _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(format)(_unref(BALANCES_TITLES).ALLOCATION_TOTAL)), 1),
                                _createElementVNode("div", _hoisted_5, [
                                    _createElementVNode("div", null, [
                                        _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(baseCurrency) === 'USD' ? 'attach_money' : 'currency_yen'), 1)
                                    ]),
                                    _createElementVNode("div", null, _toDisplayString(_unref(decimalize)(_unref(total), 'JPY', _unref(store).state.currencyInfo)), 1)
                                ]),
                                _hoisted_7
                            ], 512), [
                                [_vShow, !_unref(isLoading)]
                            ])
                        ]))
                        : _createCommentVNode("", true)
                ])
            ]));
        };
    }
});
